<div class="custom-filter-wrapper" style="border-radius: 0px !important;">
    <!-- Header with hamburger -->
    <div class="filter-header">
        <span>
            <img class="inbox-search-option" src='assets/qwyn/icons/hamburger_menu.svg' alt="hamburger_icon">
        </span>
    </div>

    <hr class="divider">

    <!-- First filter condition -->
    <div class="filter-condition">
<div class="select-wrapper">
      <!-- Trigger -->
      <button
        type="button"
        class="dropdown-trigger"
        (click)="toggleDropdown(0)"
        [class.dropdown-open]="dropdownOpenIndex === 0"
      >
        <span>{{ getOptionLabel(filterConditions[0].type) }}</span>
        <img src="assets/qwyn/icons/filter_dropdown.svg" class="select-icon" alt="dropdown_icon" />
      </button>

    <div *ngIf="dropdownOpenIndex === 0" class="dropdown-panel">
        <button
          type="button"
          *ngFor="let option of filterOptions"
          class="dropdown-option"
          [class.selected]="option.value === filterConditions[0].type"
          (click)="selectOption(0, option.value)"
        >
          {{ option.label }}
        </button>
    </div>
</div>


        <div class="input-wrapper" *ngIf="!isBlankType(filterConditions[0].type)">
            <input
                    type="text"
                    [(ngModel)]="filterConditions[0].value"
                    (ngModelChange)="onFilterChanged()"
                    placeholder="Search Filter"
            />
        </div>
    </div>

    <!-- Show second condition only when first has value or is blank/notBlank -->
    <div *ngIf="isFirstConditionSet()" class="junction-options">
        <label class="radio-label">
            <input
                    type="radio"
                    [(ngModel)]="junction"
                    value="AND"
                    (change)="onFilterChanged()"
            >
            AND
        </label>
        <label class="radio-label">
            <input
                    type="radio"
                    [(ngModel)]="junction"
                    value="OR"
                    (change)="onFilterChanged()"
            >
            OR
        </label>
    </div>

    <!-- Second filter condition -->
    <div *ngIf="isFirstConditionSet()" class="filter-condition">
<div class="select-wrapper">
      <button
        type="button"
        class="dropdown-trigger"
        (click)="toggleDropdown(1)"
        [class.dropdown-open]="dropdownOpenIndex === 1"
      >
        <span>{{ getOptionLabel(filterConditions[1].type) }}</span>
        <img src="assets/qwyn/icons/filter_dropdown.svg" class="select-icon" alt="dropdown_icon" />
      </button>

    <div *ngIf="dropdownOpenIndex === 1" class="dropdown-panel">
        <button
          type="button"
          *ngFor="let option of filterOptions"
          class="dropdown-option"
          [class.selected]="option.value === filterConditions[1].type"
          (click)="selectOption(1, option.value)"
        >
          {{ option.label }}
        </button>
    </div>
</div>


        <div class="input-wrapper" *ngIf="!isBlankType(filterConditions[1].type)">
            <input
                    type="text"
                    [(ngModel)]="filterConditions[1].value"
                    (ngModelChange)="onFilterChanged()"
                    placeholder="Search Filter"
            />
        </div>
    </div>

    <ng-container *ngIf="isFirstConditionSet()">
        <hr class="divider">

        <!-- Reset button -->
        <div class="button-wrapper">
            <button class="reset-button" (click)="resetFilter()">
                Reset
            </button>
        </div>
    </ng-container>
</div>
